import { render, staticRenderFns } from "./scenario-modelling.vue?vue&type=template&id=6bbafce8&"
import script from "./scenario-modelling.vue?vue&type=script&lang=js&"
export * from "./scenario-modelling.vue?vue&type=script&lang=js&"
import style0 from "./scenario-modelling.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports